// src/components/student/StudentPromotionPage.js
import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import StudentPromotion from './StudentPromotion';

const StudentPromotionPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box mb={3}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link 
            color="inherit" 
            href="#" 
            onClick={(e) => {
              e.preventDefault();
              navigate('/students');
            }}
            sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            Students
          </Link>
          <Typography color="text.primary">Promotion</Typography>
        </Breadcrumbs>
      </Box>
      
      <StudentPromotion />
    </Box>
  );
};

export default StudentPromotionPage;